import { AxiosRequestConfig } from 'axios';

import { apiRequest } from 'helpers';
import { SubmittedValidatedWorkClaimProps, WorkClaimProps } from 'types';
import { FullValidatedWorkClaimProps } from 'types/Claims';
export const submitValidatedWorkClaim = (
  data: SubmittedValidatedWorkClaimProps,
) => {
  return data.id
    ? // 404: "Validated work claim not found."
      // 403: employers cannot modify submitted vwcs
      apiRequest<SubmittedValidatedWorkClaimProps>({
        method: 'PATCH',
        path: `/v3/validated_work_claims/${data.id}`,
        data: data,
      })
    : // 404: "Candidate not found."
      // 404: "Organization not found."
      // 403: users can only add validated_work_claims to their orgs
      // 403: users can only add validated_work_claims to candidates in their orgs
      apiRequest<SubmittedValidatedWorkClaimProps>({
        method: 'POST',
        path: '/v3/validated_work_claims',
        data: data,
      });
};

export const fetchWorkClaimsFromCandidate = (candidate_id: number) => {
  return apiRequest<Array<WorkClaimProps>>({
    method: 'GET',
    path: '/v3/work_claims',
    data: {
      candidate_id: [candidate_id],
    },
  });
};

// 204: NO CONTENT
// 404: "Validated work claim not found."
// 403: "Non-admin user cannot delete a submitted validated work claim."
// 403: "Cannot modify a pre-signature validated work claim associated with a signed candidate."
export const deleteValidatedWorkClaim = (validated_work_claim_id: number) => {
  return apiRequest({
    method: 'DELETE',
    path: `/v3/validated_work_claims/${validated_work_claim_id}`,
  });
};

export const fetchValidatedWorkClaims = (config: AxiosRequestConfig) => {
  return apiRequest<Array<FullValidatedWorkClaimProps>>({
    method: 'GET',
    path: '/v3/validated_work_claims',
    ...config,
  });
};
